module.exports = __webpack_public_path__ + "static/media/Semi.352f1f42.png";